
<div class="p-4">
  <div class="row">
    <div class="col-12">
      <div class="label mt-2 mb-1">Select Vendors</div>

      <grid
        v-if="vendors.length"
        :data-items="vendors"
        :columns="columns"
        :style="{ height: '500px', maxHeight: '500px' }"
        style="font-size: 0.9rem"
        :filterable="false"
        :cell-render="'cellTemplate'"
        @rowclick="onRowClick"
      >
        <template v-slot:cellTemplate="{ props }">

          <template v-if="props.dataItem['isExternallyOrderedVendor'] === true">
            <td v-if="props.field === 'selected'">
              <div class="d-flex align-items-center">
                <input
                    type="checkbox"
                    class="form-check-inputs"
                    id="exampleCheck1"
                    :checked="isSelected(props.dataItem['id'])"
                    @input="onRowClick(props)"
                />
                <i v-if="selectedVendors.indexOf(props.dataItem['id']) !== -1"
                   class="far fa-info-circle ml-2" v-b-tooltip="'Vendor already added to MaterialRequest'"></i>
              </div>
            </td>

            <td v-else-if="props.field === 'name'">
              <span class="badge badge-info">EXTERNALLY ORDERED</span> {{ props.dataItem[props.field] }}
            </td>

            <td v-else>
              --
            </td>
          </template>
          <template v-else>
          <td v-if="props.field === 'name'">
            <div class="d-flex justify-content-between items-center">
              <div>
            {{ props.dataItem[props.field] }}
            </div>
            <span class="badge" v-if="props.dataItem['isAmosVendor']">
              AMOS
            </span>
            </div>
          </td>

            <td v-else-if="props.field === 'favorite'">
              <i class="far fa-star" v-if="props.dataItem['isFavorite']"></i>
            </td>

          <td v-else-if="props.field === 'email'">
            <div v-for="contact in props.dataItem['vendorContacts'].filter(_=> _.contactType == 'email')" :key="contact.id">
              <i class="far fa-envelope"></i>
              {{ contact.contact }}
            </div>

          </td>

          <td v-else-if="props.field === 'selected'">
            <div class="d-flex align-items-center">
            <input
              type="checkbox"
              class="form-check-inputs"
              id="exampleCheck1"
              :checked="isSelected(props.dataItem['id'])"
              @input="onRowClick(props)"
            />

            <i v-if="selectedVendors.indexOf(props.dataItem['id']) !== -1"
                class="far fa-info-circle ml-2" v-b-tooltip="'Vendor already added to MaterialRequest'"></i>
            </div>
          </td>

          <td v-else-if="props.field === 'distance'">
            <span v-if="props.dataItem[props.field] == 0">N/A</span>
            <span v-else>{{ props.dataItem[props.field] }}</span>
          </td>

          <td v-else>
            {{ props.dataItem[props.field] }}
          </td>
          </template>
        </template>
      </grid>
    </div>

    <div class="col-12 mt-2 d-flex justify-content-between">
      <button class="badgebutton ml-2" @click="cancel">
        <i class="far fa-times"></i>
        Cancel
      </button>
      <button class="badgebutton active" @click="selectVendors" :disabled="!addedVendors.length">
        <i class="far fa-plus"></i>
        Select vendors
      </button>
    </div>
  </div>
</div>
